import { ProductGate } from "./ProductGate";

export function ByoncApp() {
  return <ProductGate appId="byonc" />;
}
